import React from 'react'
import ChatConversationList from '../components/chat-components/chat-conversation-list'
import ChatBox from '../components/chat-components/chat-box'
import NoChat from '../components/chat-components/no-chat'
import UseChat from '../utils/useChat'

const Chat: React.FC = () => {
    const { currentConversation } = UseChat()

    return (
        <div className='w-full h-screen smallTablet:h-[100dvh] bg-background flex overflow-hidden'>
            <ChatConversationList />
            {currentConversation ? <ChatBox /> : <NoChat />}
        </div>
    )
}

export default Chat
